(() => {
  const root = document.documentElement;
  const updateScrollState = () => root.classList.toggle('neps-page-scrolled', window.scrollY > 18);
  updateScrollState();
  window.addEventListener('scroll', updateScrollState, { passive: true });

  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  const revealTargets = document.querySelectorAll('.shopify-section > section, .shopify-section > .page-width, .product-grid > li');
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  revealTargets.forEach((item) => item.classList.add('neps-reveal'));
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('neps-reveal--visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -35px' });
  revealTargets.forEach((item) => observer.observe(item));
})();
